import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { Trans, useTranslation } from "react-i18next";

import Styles from "../SleepingCustomer.module.scss";
import Heading from "../Heading/Heading";
import ActivateNewCs from "./ActivateNewCS/ActivateNewCS";
import Responsive from "@/cms/components/Common/Responsive";
import { DashboardRoute } from "@/routes/dashboard";

type Props = {
  category: {
    categoryName: string,
    slug: string,
  },
  address: {
    postalcode: string,
    location: string,
    street: string,
    streetNumber: string,
  },
};

const Confirmation = ({ category, address }: Props) => {
  const { t } = useTranslation("sleepingCustomer");

  return (
    <div className={Styles.ConfirmationWrapper}>
      <div className={Styles.ConfirmationWrapperWithoutGreenPanel}>
        <Heading categoryName={category.categoryName} address={address} subheading={false} />
        <div className={Styles.confirmation}>
          <Icon name="check circle outline" size="big" color="green" />
          <span className={`${Styles.confirmationText} theme-color-primary`}>
            <Responsive minWidth={768}>
              <Trans i18nKey="sleepingCustomer:confirmation.desk">
                <br />
              </Trans>
            </Responsive>
            <Responsive {...Responsive.onlyMobile}>{t("confirmation.mobile")}</Responsive>
          </span>
        </div>

        <div className={Styles.buttonsContainer}>
          <a className={Styles.toDashboard} href={DashboardRoute}>
            <Button primary className={Styles.toDashboard}>
              {t("toDashboard")}
              <Icon name="arrow right" />
            </Button>
          </a>
        </div>
      </div>

      <ActivateNewCs category={category} />
    </div>
  );
};

export default Confirmation;
